import Button from '../../atoms/Button';
import LogoWithTitle from '../../molecules/LogoWithTitle';
import {
  DidntReceiveLabel,
  EmailLabel,
  FooterWrapper,
  ForgotPasswordStepTwoContainer,
  LogoWrapper,
  Subheader,
} from './ForgotPasswordStepTwo.styled';

interface ForgotPasswordStepTwoProps {
  email: string;
  onResendClick: () => void;
  resendDisabled?: boolean;
}

const ForgotPasswordStepTwo = (props: ForgotPasswordStepTwoProps) => {
  return (
    <ForgotPasswordStepTwoContainer>
      <LogoWrapper>
        <LogoWithTitle title='Check your Email' gap={80} />
      </LogoWrapper>
      <Subheader>We sent a password reset link to</Subheader>
      <EmailLabel>{props.email}</EmailLabel>
      <FooterWrapper>
        <DidntReceiveLabel>Didn't receive the email?</DidntReceiveLabel>
        <Button
          size='lg'
          variant='link'
          onClick={props.onResendClick}
          disabled={props.resendDisabled}
        >
          CLICK TO RESEND
        </Button>
      </FooterWrapper>
    </ForgotPasswordStepTwoContainer>
  );
};

export default ForgotPasswordStepTwo;
